<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <h1 class="display-1">Edit Price</h1>
        <v-text-field label="Width" v-model="width"></v-text-field>
        <v-text-field label="Drop" v-model="drop"></v-text-field>
        <v-text-field label="Price" v-model="price"></v-text-field>
        <v-btn large color="primary" @click="updatePrice">Update</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PriceService from '@/services/PriceService'
export default {
  name: 'EditPrice',
  data () {
    return {
      width: null,
      drop: null,
      price: null
    }
  },
  mounted () {
    this.getPrice()
  },
  methods: {
    async getPrice () {
      const response = await PriceService.getPrice({
        id: this.$route.params.id
      })
      this.width = response.data.width
      this.drop = response.data.drop
      this.price = response.data.price
    },
    async updatePrice () {
      await PriceService.updatePrice({
        id: this.$route.params.id,
        width: this.width,
        drop: this.drop,
        price: this.price
      })
      this.$router.push({ name: 'Prices' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/prices/EditPrice.vue